module.exports = __webpack_public_path__ + "img/android-icon-48x48.7de1474a.png";